import {Checkbox, Text} from '@mantine/core';
import {type FC, useState} from 'react';
import type {GetUnfinishedEntryPromptResponse} from '../../../../core/entities/recruitment/schema';
import {PromptModal} from '../../../../shared/components/PromptModal';
import {PostRegisterEntryPromptCard} from '../../../postRegisterEntryPrompt/components/Presenter/PostRegisterEntryPromptCard';

export const UNFINISHED_ENTRY_PROMPT_COMPONENT_ID = 'unfinished-entry-prompt';

type Props = {
  opened: boolean;
  // チェックボックスの状態を渡し、チェックされていれば呼び出し側で長く止める
  onClose: (withSuppression: boolean) => void;
  recruitments: GetUnfinishedEntryPromptResponse['recruitments'];
};

export const UnfinishedEntryPromptModal: FC<Props> = ({
  opened,
  onClose,
  recruitments,
}) => {
  const [checked, setChecked] = useState(false);

  if (recruitments.length === 0) {
    return null;
  }

  return (
    <PromptModal
      opened={opened}
      // ×と背景のどちらで閉じてもチェックボックスの状態を反映する
      onClose={() => onClose(checked)}
      // 閉じたときのチェック状態で計測名を分けるため
      componentId={
        checked
          ? `${UNFINISHED_ENTRY_PROMPT_COMPONENT_ID}-suppress`
          : UNFINISHED_ENTRY_PROMPT_COMPONENT_ID
      }
      // 閉じる操作を×と背景に絞り、チェックボックスの効き方を分かりやすくする
      withLaterButton={false}
      withOverlayGtmClick
    >
      <Text
        component="h2"
        className="text-md text-black-1 font-bold text-center"
        // 中身が縦に長くても50%表示の条件を満たせるよう、常に見える見出しで表示を計測する
        data-gtm-imp="imp_unfinished_entry_prompt"
      >
        エントリーが未完了の募集があります
      </Text>

      <div className="flex flex-col gap-8">
        {recruitments.map((recruitment) => (
          <PostRegisterEntryPromptCard
            key={recruitment.id}
            recruitment={recruitment}
            isQuickEntry={recruitment.isQuickEntry}
            componentId={UNFINISHED_ENTRY_PROMPT_COMPONENT_ID}
          />
        ))}
      </div>

      <Checkbox
        label="しばらくこのメッセージを表示しない"
        checked={checked}
        onChange={(e) => setChecked(e.currentTarget.checked)}
        size="sm"
        className="mx-auto"
      />
    </PromptModal>
  );
};
